import { useQuery } from '@tanstack/react-query';
import { MMEApi } from '../../../apis/MMEApi/MMEApi.ts';
import { ISavedMMECalculation } from '../MME.ts';
import { QueryKeys } from '../../../queryDefaults/QueryKeys.ts';
import { AppMedError } from '../../../error/AppMedError.ts';

export function useGetSavedMMECalculations(patientID: number | undefined) {
    return useQuery<ISavedMMECalculation[], AppMedError>({
        queryKey: [QueryKeys.mmeSavedCalculations, patientID],
        queryFn: async () => {
            if (!patientID) 
                throw new Error('Patient ID is required');
            
            return await MMEApi.getSavedCalculations(patientID);
        },
        enabled: !!patientID,
    });
}

